import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Navbar from "../../components/navbar/navbarComponent";
import NavBar2 from "./botonesIngreso/botonesIngreso";
import CardsComponent from "./cards/cardsComponent";
import PaginationComponent from "./pagination/paginationComponent";
import { getSecuestros } from "../../redux/actions";

function Home() {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const fetchSecuestros = async (
    page = 1,
    filter = "todos",
    vehicleType = "todos",
    limit = 9
  ) => {
    try {
      setLoading(true);
      setError(false);

      await dispatch(
        getSecuestros(page, filter, vehicleType, limit)
      );
    } catch (error) {
      console.error("Error al cargar los secuestros:", error);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSecuestros();
  }, []);

  return (
    <div className="bg-[#F5FAFF] min-h-screen">
      <Navbar />

      <NavBar2 />

      <CardsComponent
        loading={loading}
        error={error}
        fetchSecuestros={fetchSecuestros}
      />

      <PaginationComponent
        fetchSecuestros={fetchSecuestros}
      />
    </div>
  );
}

export default Home;